"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[441],{

/***/ 79315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m6 9 6 6 6-6"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronDown);

/***/ }),

/***/ 76058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m9 18 6-6-6-6"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronRight);

/***/ }),

/***/ 77893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgEllipsisH = function SvgEllipsisH(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.895 11.895A1.893 1.893 0 0 1 12 13.789a1.893 1.893 0 0 1-1.895-1.894c0-1.048.847-1.895 1.895-1.895s1.895.847 1.895 1.895zM19.105 10a1.893 1.893 0 0 0-1.894 1.895c0 1.048.846 1.894 1.894 1.894A1.893 1.893 0 0 0 21 11.895 1.893 1.893 0 0 0 19.105 10zm-14.21 0A1.893 1.893 0 0 0 3 11.895c0 1.048.847 1.894 1.895 1.894a1.893 1.893 0 0 0 1.894-1.894A1.893 1.893 0 0 0 4.895 10z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgEllipsisH);

/***/ }),

/***/ 21098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00FF51"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.172 24.728v-7.482h-2.536v-2.973h2.536V11.93c0-2.544 1.574-3.93 3.871-3.93 1.101 0 2.047.082 2.32.118v2.659H18.77c-1.25 0-1.49.588-1.49 1.448v2.048h2.82l-.388 2.973H17.28v7.481",
    fill: "#000"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgSocialFacebook);

/***/ }),

/***/ 11890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSocialInstagram = function SvgSocialInstagram(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00FF51"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.634 12.424c-.066-1.396-.384-2.632-1.404-3.65-1.016-1.02-2.25-1.338-3.642-1.408-1.435-.082-5.737-.082-7.172 0-1.389.066-2.622.385-3.642 1.403-1.02 1.019-1.334 2.255-1.404 3.65-.082 1.439-.082 5.75 0 7.189.066 1.395.384 2.631 1.404 3.65 1.02 1.018 2.25 1.337 3.642 1.407 1.435.082 5.737.082 7.172 0 1.392-.066 2.626-.385 3.642-1.407 1.016-1.019 1.334-2.255 1.404-3.65.082-1.439.082-5.746 0-7.184Zm-3.991-.016c.574 0 1.04-.463 1.04-1.042a1.04 1.04 0 1 0-1.04 1.042Zm-4.64-.86a4.455 4.455 0 0 0-4.456 4.468 4.455 4.455 0 0 0 4.457 4.466 4.455 4.455 0 0 0 4.457-4.466 4.455 4.455 0 0 0-4.457-4.467Zm0 7.371a2.903 2.903 0 0 1 0-5.808 2.903 2.903 0 0 1 0 5.809Zm5.125 3.888a2.936 2.936 0 0 0 1.652-1.656c.39-.98.368-3.125.354-4.515-.003-.23-.005-.44-.005-.62s.002-.39.005-.621c.014-1.39.035-3.531-.354-4.515a2.936 2.936 0 0 0-1.652-1.656c-.981-.388-3.131-.367-4.518-.354-.225.002-.43.004-.606.004-.18 0-.39-.002-.62-.004-1.386-.014-3.523-.036-4.504.354a2.937 2.937 0 0 0-1.652 1.656c-.388.984-.367 3.138-.354 4.528.003.225.005.43.005.608 0 .18-.003.39-.005.62-.014 1.39-.036 3.531.354 4.515a2.937 2.937 0 0 0 1.652 1.656c.981.388 3.131.367 4.518.354.225-.002.43-.004.606-.004.18 0 .39.002.62.004 1.385.014 3.522.036 4.504-.354Z",
    fill: "#000"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgSocialInstagram);

/***/ }),

/***/ 5359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSocialLinkedin = function SvgSocialLinkedin(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00FF51"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.786 8H9.21C8.543 8 8 8.55 8 9.226v14.548A1.22 1.22 0 0 0 9.21 25h14.576c.668 0 1.214-.55 1.214-1.226V9.226C25 8.55 24.454 8 23.786 8ZM13.138 22.571h-2.52v-8.113h2.524v8.113h-.004Zm-1.26-9.22a1.462 1.462 0 0 1 0-2.922c.805 0 1.461.656 1.461 1.46a1.46 1.46 0 0 1-1.46 1.461Zm10.705 9.22h-2.52v-3.946c0-.941-.019-2.152-1.309-2.152-1.313 0-1.514 1.025-1.514 2.084v4.014h-2.52v-8.113h2.417v1.108h.035c.337-.637 1.16-1.309 2.386-1.309 2.55 0 3.025 1.681 3.025 3.867v4.447Z",
    fill: "#000"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgSocialLinkedin);

/***/ }),

/***/ 10410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSocialTwitter = function SvgSocialTwitter(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00FF51"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M24.944 12.738c.013.164.013.328.013.492 0 5.004-4.124 10.77-11.663 10.77-2.322 0-4.48-.621-6.294-1.7.33.036.647.048.99.048 1.916 0 3.68-.598 5.089-1.617-1.802-.036-3.313-1.126-3.833-2.626.254.036.508.059.774.059.368 0 .736-.047 1.079-.129-1.878-.351-3.287-1.875-3.287-3.715v-.047c.546.282 1.18.457 1.853.48-1.104-.679-1.827-1.839-1.827-3.152 0-.703.203-1.347.558-1.91 2.018 2.297 5.05 3.797 8.452 3.961a3.961 3.961 0 0 1-.102-.867c0-2.086 1.828-3.785 4.1-3.785 1.18 0 2.245.457 2.994 1.195a8.486 8.486 0 0 0 2.602-.914c-.305.88-.952 1.617-1.802 2.086a8.761 8.761 0 0 0 2.36-.586 8.478 8.478 0 0 1-2.056 1.957Z",
    fill: "#000"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgSocialTwitter);

/***/ }),

/***/ 20090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgReleaseitLogoGreen = function SvgReleaseitLogoGreen(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 33"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M28.42 11.896c4.817 0 8.521 3.28 8.67 8.49 0 .984-.815 1.712-1.742 1.712h-12.04c.37 2.624 2.52 4.264 5.297 4.264 1.816 0 2.853-.62 4.113-1.64.63-.51 1.667-.765 2.445-.146.704.547.74 1.677.074 2.369-1.741 1.785-4.26 2.696-6.817 2.696-4.927 0-8.892-3.534-8.892-8.927s3.965-8.818 8.892-8.818zm26.016 0c4.817 0 8.521 3.28 8.67 8.49 0 .984-.815 1.712-1.741 1.712H49.324c.37 2.624 2.52 4.264 5.298 4.264 1.815 0 2.853-.62 4.112-1.64.63-.51 1.667-.765 2.445-.146.704.547.741 1.677.074 2.369-1.74 1.785-4.26 2.696-6.817 2.696-4.927 0-8.891-3.534-8.891-8.927s3.964-8.818 8.891-8.818zm19.305 0c2.052 0 4.58.838 5.753 2.77v-.693c0-1.02.806-1.895 1.832-1.895 1.1 0 1.942.874 1.942 1.895v13.591c0 1.02-.842 1.895-1.942 1.895-1.026 0-1.832-.875-1.832-1.895v-.729c-1.136 1.859-3.627 2.806-5.753 2.806-4.617 0-8.684-3.462-8.684-8.891 0-5.43 4.067-8.854 8.684-8.854zm18.426 0c2.25 0 4.317.728 5.442 2.514.507.874.253 1.749-.327 2.186-.616.51-1.378.474-2.176-.218-.944-.838-2.032-1.166-2.902-1.166-.943 0-1.995.328-2.358.91-.29.474-.326.948-.145 1.458.217.656 1.233.984 2.14 1.239l2.612.656c3.663.91 4.425 3.316 4.425 5.028 0 3.28-2.865 5.138-6.747 5.138-2.611 0-5.26-1.385-6.166-3.863-.29-.91.108-1.748.906-2.04.907-.364 1.596.109 1.886.73.69 1.31 1.996 2.04 3.665 2.04 1.704 0 2.938-.766 2.938-2.04 0-1.094-1.052-1.568-2.286-1.86l-2.285-.546c-3.591-.984-4.897-2.952-4.68-5.684.218-2.515 2.939-4.482 6.058-4.482zm16.903 0c4.817 0 8.522 3.28 8.67 8.49 0 .984-.815 1.712-1.741 1.712h-12.041c.37 2.624 2.52 4.264 5.298 4.264 1.815 0 2.852-.62 4.112-1.64.63-.51 1.667-.765 2.445-.146.704.547.741 1.677.074 2.369-1.74 1.785-4.26 2.696-6.817 2.696-4.927 0-8.891-3.534-8.891-8.927s3.964-8.818 8.891-8.818zm12.553.04c1.14 0 2.013.892 2.013 1.93v13.845c0 1.04-.873 1.93-2.013 1.93-1.063 0-1.899-.89-1.899-1.93V13.867c0-1.04.836-1.93 1.9-1.93zm8.464-6.612c1.12 0 1.98.892 1.98 1.933v4.834h2.278c.859 0 1.606.706 1.606 1.636 0 .855-.747 1.524-1.606 1.524h-2.278v12.456c0 1.041-.86 1.934-1.98 1.934-1.046 0-1.868-.893-1.868-1.934V15.251h-1.718c-.86 0-1.607-.669-1.607-1.524 0-.93.748-1.636 1.607-1.636h1.718V7.257c0-1.041.822-1.933 1.868-1.933zM4.473 5.59v.012h4.062l.06.003c.04.001.08.002.121.006l.08.011.105.016c.03.006.058.014.087.021l.094.024c.03.01.06.02.088.031a1.116 1.116 0 0 1 .177.074c.026.012.053.024.079.038l.094.055.066.04c.035.025.07.05.103.077l.045.032 8.11 6.635c.303.248.544.572.66.948a1.93 1.93 0 0 1-.618 2.067l-6.072 4.967a.273.273 0 0 0-.001.422L17.842 26c.77.63.982 1.756.432 2.587-.374.565-.978.86-1.588.86-.421 0-.845-.141-1.198-.43L7.336 22.35c-.028-.023-.053-.047-.079-.071-.019-.018-.04-.034-.058-.053a2.095 2.095 0 0 1-.142-.157l-.005-.007a1.707 1.707 0 0 1-.108-.149l-.024-.04a1.478 1.478 0 0 1-.07-.122l-.037-.078c-.014-.03-.028-.059-.04-.09l-.037-.103c-.008-.023-.017-.046-.024-.07a2.111 2.111 0 0 1-.029-.114l-.015-.066c-.007-.037-.012-.074-.017-.11l-.01-.074c-.003-.033-.004-.067-.005-.1-.002-.03-.004-.058-.004-.087 0-.029.002-.057.004-.086.001-.033.002-.066.005-.1l.01-.074a2.09 2.09 0 0 1 .017-.11l.015-.066c.01-.039.018-.076.029-.114.007-.024.016-.047.024-.07.012-.035.023-.07.037-.103.012-.031.027-.06.04-.09.012-.027.023-.053.037-.078.021-.042.046-.083.071-.123.008-.013.014-.026.023-.039a1.76 1.76 0 0 1 .113-.155l.05-.06.053-.055.029-.033c.012-.013.026-.024.039-.036.035-.034.07-.067.107-.097v-.001l5.815-4.756a.547.547 0 0 0 0-.845L7.86 9.441H4.473v18.087a1.91 1.91 0 0 1-2.03 1.915c-1.012-.066-1.776-.958-1.776-1.98V5.59h3.806zm36.519-2.896c1.077 0 1.951.858 1.951 1.916v22.456c0 1.058-.874 1.917-1.951 1.917-1.078 0-1.951-.859-1.951-1.917V4.611c0-1.058.873-1.916 1.95-1.916zm33.19 12.844c-2.859 0-5.24 2.04-5.24 5.175 0 3.133 2.381 5.283 5.24 5.283 2.784 0 5.275-1.931 5.275-5.283 0-3.352-2.711-5.175-5.276-5.175zm-45.762-.364c-2.668 0-4.742 1.567-5.112 4.19h10.04c-.37-2.66-2.334-4.19-4.928-4.19zm26.016 0c-2.667 0-4.742 1.567-5.112 4.19h10.04c-.37-2.66-2.334-4.19-4.928-4.19zm54.634 0c-2.667 0-4.742 1.567-5.112 4.19h10.04c-.37-2.66-2.334-4.19-4.928-4.19zm12.592-12.48c1.443 0 2.582 1.04 2.582 2.412 0 1.374-1.14 2.413-2.582 2.413-1.406 0-2.621-1.04-2.621-2.413 0-1.373 1.215-2.412 2.62-2.412z",
    fill: "#00FF51",
    fillRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgReleaseitLogoGreen);

/***/ }),

/***/ 70441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DefaultLayout": function() { return /* binding */ DefaultLayout; },
  "NAVIGATION_QUERY": function() { return /* binding */ NAVIGATION_QUERY; },
  "default": function() { return /* binding */ layout_DefaultLayout; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(12483);
// EXTERNAL MODULE: ../../node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(23848);
// EXTERNAL MODULE: ./src/utils/graphql-client.ts
var graphql_client = __webpack_require__(10089);
;// CONCATENATED MODULE: ./src/features/auth/hooks/use-auth-refresh.ts




function useAuthRefresh() {
    var ref = (0,next_auth_react.useSession)(), session = ref.data;
    // On session change
    react.useEffect(function() {
        // Update the authorization header
        graphql_client/* gqlClient.headers.set */.N.headers.set("Authorization", session ? "Bearer ".concat(session.accessToken) : "");
        // And set user in sentry
        esm_exports/* setUser */.av(session ? session.user : null);
    }, [
        session
    ]);
}

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../packages/ui/src/divider/Divider.tsx
var Divider = __webpack_require__(82002);
// EXTERNAL MODULE: ../../packages/ui/src/link/Link.tsx
var Link = __webpack_require__(48994);
// EXTERNAL MODULE: ../../packages/ui/src/collapsible/Collapsible.tsx
var Collapsible = __webpack_require__(46348);
// EXTERNAL MODULE: ../../packages/assets/icons/chevron-down.svg
var chevron_down = __webpack_require__(79315);
;// CONCATENATED MODULE: ./src/components/layout/footer/data.ts
var FOOTER_GROUPS = [
    {
        title: "About Us",
        links: [
            {
                title: "Our Company",
                href: "/about"
            },
            {
                title: "How Releaseit Works",
                href: "/page/how-releaseit-works"
            },
            {
                title: "Blog",
                href: "/blog"
            },
            {
                title: "Categories",
                href: "/category"
            },
            {
                title: "Communities",
                href: "/community"
            }, 
        ]
    },
    {
        title: "For Owners",
        links: [
            {
                title: "List an Item",
                href: "/create-listing"
            },
            {
                title: "Business Portal",
                href: "https://portal.releaseit.com.au"
            },
            {
                title: "Partner with Releaseit",
                href: "/rental-businesses"
            }, 
        ]
    },
    {
        title: "Support",
        links: [
            {
                title: "FAQs",
                href: "/page/faqs"
            },
            {
                title: "Contact Us",
                href: "/contact"
            },
            {
                title: "Staying COVID Safe",
                href: "/page/staying-covid-safe"
            }, 
        ]
    },
    {
        title: "Legal",
        links: [
            {
                title: "Privacy Policy",
                href: "/page/privacy-policy"
            },
            {
                title: "Terms of Use",
                href: "/page/terms-of-use"
            },
            {
                title: "Cancellation Policy",
                href: "/page/cancellation-policy"
            },
            {
                title: "Dispute Resolution Policy",
                href: "/page/dispute-resolution-policy"
            },
            {
                title: "Review Policy",
                href: "/page/review-policy"
            }, 
        ]
    }, 
];

;// CONCATENATED MODULE: ./src/components/layout/footer/FooterBelow.tsx





function FooterBelow() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-800",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col gap-y-8 pt-4 pb-12 md:pt-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterNav, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                    className: "invisible bg-gray-700 md:visible md:mt-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Legal, {})
            ]
        })
    });
}
function FooterNav() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "hidden gap-x-4 md:flex",
                children: FOOTER_GROUPS.map(function(group) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 space-y-4 text-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "font-medium text-gray-500",
                                children: group.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "space-y-2 text-white",
                                children: group.links.map(function(link) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: link.href,
                                            passHref: true,
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                variant: "unstyled",
                                                isSubtle: true,
                                                children: link.title
                                            })
                                        })
                                    }, link.href);
                                })
                            })
                        ]
                    }, group.title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "block px-8 md:hidden",
                children: FOOTER_GROUPS.map(function(group) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapsible/* Collapsible */.zF, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapsible/* Collapsible.Trigger */.zF.Trigger, {
                                className: " flex w-full items-center justify-between border-b border-gray-600 py-3 text-white ring-white/25 transition focus-visible:outline-none focus-visible:ring-4 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "truncate font-medium",
                                        children: group.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_down/* default */.Z, {
                                        className: "h-8 w-8"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* Collapsible.Content */.zF.Content, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "space-y-2 py-2 text-white",
                                    children: group.links.map(function(link) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: link.href,
                                                passHref: true,
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                    variant: "unstyled",
                                                    isSubtle: true,
                                                    children: link.title
                                                })
                                            })
                                        }, link.href);
                                    })
                                })
                            })
                        ]
                    }, group.title);
                })
            })
        ]
    });
}
function Legal() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-4 text-sm text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "px-2 text-center md:px-0 md:text-left",
                children: "\u201CWe don't buy it\u201D and \u201CWe don't buy it. You shouldn't either\u201D are trademarks of Releaseit Holdings Pty Ltd."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center gap-4 md:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "\xa92022 Releaseit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                        className: "flex gap-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/page/terms-of-use",
                                passHref: true,
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    variant: "unstyled",
                                    isSubtle: true,
                                    children: "Terms & Conditions"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "aria-hidden": true,
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/page/privacy-policy",
                                passHref: true,
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    variant: "unstyled",
                                    isSubtle: true,
                                    children: "Privacy"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/assets/images/releaseit-logo-green.svg
var releaseit_logo_green = __webpack_require__(20090);
;// CONCATENATED MODULE: ./src/components/layout/footer/Socials.tsx

/* eslint-disable global-require */ 
var SOCIALS = [
    {
        label: "Instagram",
        icon: (__webpack_require__(11890)/* ["default"] */ .Z),
        href: "https://www.instagram.com/releaseitau"
    },
    {
        label: "Twitter",
        icon: (__webpack_require__(10410)/* ["default"] */ .Z),
        href: "https://twitter.com/releaseitau"
    },
    {
        label: "Facebook",
        icon: (__webpack_require__(21098)/* ["default"] */ .Z),
        href: "https://www.facebook.com/releaseitau"
    },
    {
        label: "LinkedIn",
        icon: (__webpack_require__(5359)/* ["default"] */ .Z),
        href: "https://www.linkedin.com/company/releaseit"
    }, 
];
function Socials() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-800 md:bg-black",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col items-center justify-between gap-y-6 py-6 md:flex-row md:py-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(releaseit_logo_green/* default */.Z, {
                    height: 40
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex items-center gap-x-4",
                        children: SOCIALS.map(function(social) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: social.href,
                                    "aria-label": social.label,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(social.icon, {
                                        className: "h-10 w-10"
                                    })
                                })
                            }, social.label);
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/layout/footer/Footer.tsx



function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        id: "footer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Socials, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBelow, {})
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
;// CONCATENATED MODULE: ./src/components/layout/header/HeaderPromoBar.tsx


function HeaderPromoBar() {
    var data = (0,es.useQuery)({
        queryKey: "banner",
        queryFn: function() {
            return fetch("/api/banner").then(function(res) {
                return res.text();
            });
        },
        staleTime: Infinity
    }).data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "header-promo-bar",
        className: "prose max-w-none bg-primary-green p-2 text-center text-sm text-black prose-a:font-normal prose-a:text-black md:text-base",
        // This gets sanitized on the server and is safe to use.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: data !== null && data !== void 0 ? data : "Loading..."
        }
    });
}

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../packages/ui/src/button/Button.tsx
var Button = __webpack_require__(43231);
;// CONCATENATED MODULE: ../../packages/assets/icons/plus.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "plus_svg__feather plus_svg__feather-plus"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 5v14M5 12h14"
  })));
};

/* harmony default export */ var plus = (SvgPlus);
// EXTERNAL MODULE: ./src/generated/graphql.ts + 1 modules
var graphql = __webpack_require__(36998);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-navigation-menu/dist/index.module.js + 15 modules
var index_module = __webpack_require__(77531);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/assets/icons/chevron-right.svg
var chevron_right = __webpack_require__(76058);
;// CONCATENATED MODULE: ../../packages/assets/icons/menu.svg
var menu_path;

function menu_extends() { menu_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }



var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/react.createElement("svg", menu_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), menu_path || (menu_path = /*#__PURE__*/react.createElement("path", {
    d: "M20.759 5.946H3.24a.241.241 0 0 1-.24-.24V4.74c0-.133.108-.241.241-.241H20.76c.133 0 .241.108.241.241v.964a.241.241 0 0 1-.241.241zm0 6.429H3.24a.241.241 0 0 1-.24-.241v-.964c0-.133.108-.241.241-.241H20.76a.24.24 0 0 1 .241.24v.965a.241.241 0 0 1-.241.241zm0 6.429H3.24a.241.241 0 0 1-.24-.241v-.965a.24.24 0 0 1 .241-.24H20.76a.24.24 0 0 1 .241.24v.965a.241.241 0 0 1-.241.24z",
    fill: "currentColor"
  })));
};

/* harmony default export */ var menu = (SvgMenu);
;// CONCATENATED MODULE: ./src/components/layout/header/CategoryMegaMenu.tsx







function CategoryMegaMenu() {
    var data = (0,graphql/* useNavigationQuery */.vt)({}, {
        staleTime: Infinity
    }).data;
    var nav = data === null || data === void 0 ? void 0 : data.Navigation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootCategoryMenu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RootCategoryMenuTrigger, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RootCategoryMenuContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryMenu, {
                    children: nav === null || nav === void 0 ? void 0 : nav.categories.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubCategoryMenuItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryMenuTrigger, {
                                    label: category.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryMenuContent, {
                                    category: category
                                })
                            ]
                        }, category.title);
                    })
                })
            })
        ]
    });
}
/** Internal components */ function RootCategoryMenu(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Root */.fC, {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Item */.ck, {
            className: "h-full list-none",
            children: children
        })
    });
}
function RootCategoryMenuTrigger() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/category",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "sr-only",
                    children: "categories"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Trigger */.xz, {
                className: "flex h-full items-center gap-x-2 ring-inset ring-black/25 focus:outline-none focus-visible:ring-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu, {
                        className: "h-5 w-5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Categories"
                    })
                ]
            })
        ]
    });
}
function RootCategoryMenuContent(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Content */.VY, {
        style: {
            perspective: 2000
        },
        className: " absolute top-full left-0 z-10 origin-top radix-state-open:animate-slide-down radix-state-closed:animate-scale-out-content ",
        children: children
    });
}
function SubCategoryMenu(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Sub */.Tr, {
        orientation: "vertical",
        className: "relative flex w-64 flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Viewport */.l_, {
                style: {
                    width: "calc(85vw - 270px)",
                    maxWidth: 896,
                    height: "max(var(--radix-navigation-menu-viewport-height), 100%)",
                    background: "linear-gradient(90deg, #fff 75%, #edeef0 75%)"
                },
                className: " absolute left-full overflow-hidden shadow-card transition-[height] radix-state-open:animate-enter-from-left radix-state-closed:animate-exit-to-left "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* List */.aV, {
                className: "z-10 bg-gray-100 shadow-card",
                children: children
            })
        ]
    });
}
function SubCategoryMenuItem(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Item */.ck, {
        children: children
    });
}
function SubCategoryMenuTrigger(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Trigger */.xz, {
        className: "inline-flex h-12 w-full items-center justify-between bg-off-white pl-6 pr-3 text-black ring-inset ring-black/25 focus-visible:outline-none focus-visible:ring-4 radix-state-open:bg-gray-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {
                className: "h-6 w-6"
            })
        ]
    });
}
function SubCategoryMenuContent(param) {
    var category = param.category;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Content */.VY, {
        className: " absolute top-0 left-0 flex radix-motion-from-start:animate-enter-from-top radix-motion-to-start:animate-exit-to-top radix-motion-from-end:animate-enter-from-bottom radix-motion-to-end:animate-exit-to-bottom ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-3/4 p-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-baseline gap-x-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-2xl font-medium",
                                children: category.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/hire/".concat(category.href),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Link */.rU, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        variant: "neutral",
                                        isSubtle: true,
                                        children: "View all"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "columns-[150px_4] gap-10 py-6",
                        children: category.children.map(function(subcategory) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryNavGroup, {
                                heading: subcategory.title,
                                href: subcategory.href,
                                itemType: "category",
                                items: subcategory.children
                            }, subcategory.title);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/4 p-6 pt-14",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryNavGroup, {
                    heading: "Popular Brands",
                    itemType: "brand",
                    items: category.popularBrands
                })
            })
        ]
    });
}
function SubCategoryNavGroup(param) {
    var heading = param.heading, itemType = param.itemType, href = param.href, items = param.items;
    var hrefBase = itemType === "category" ? "/hire" : "/brand";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-5 break-inside-avoid space-y-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href ? "".concat(hrefBase, "/").concat(href) : "#",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Link */.rU, {
                    asChild: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        className: classnames_default()("block pb-2 text-base font-medium text-black no-underline hover:text-mid-green", items.length > 0 && "border-b"),
                        children: heading
                    })
                })
            }),
            items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "text-sm",
                children: items.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "truncate py-1.5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(hrefBase, "/").concat(item.href),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Link */.rU, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    className: "text-gray-800 no-underline hover:text-mid-green",
                                    children: item.title
                                })
                            })
                        })
                    }, item.title);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/layout/header/NavBar.tsx








function NavBar() {
    var session = (0,next_auth_react.useSession)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "border-b border-gray-200 bg-gray-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container grid h-12 grid-cols-[1fr_auto_1fr] gap-x-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryMegaMenu, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoLinks, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-x-4 justify-self-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            as: "a",
                            href: "/create-listing",
                            variant: "filled-neutral",
                            size: "sm",
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(plus, {
                                className: "h-4 w-4"
                            }),
                            children: "List Item"
                        }),
                        session.status === "authenticated" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileLink, {
                            image: session.data.user.image
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton, {})
                    ]
                })
            ]
        })
    });
}
function PromoLinks() {
    var data = (0,graphql/* useNavigationQuery */.vt)({}, {
        staleTime: Infinity
    }).data;
    var nav = data === null || data === void 0 ? void 0 : data.Navigation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "flex items-center justify-center gap-x-6 text-sm",
        children: nav === null || nav === void 0 ? void 0 : nav.promoLinks.map(function(promoLink) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: promoLink.href,
                    passHref: true,
                    prefetch: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        isSubtle: true,
                        variant: "unstyled",
                        children: promoLink.title
                    })
                })
            }, promoLink.href);
        })
    });
}
function ProfileLink(param) {
    var image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/my-account",
        passHref: true,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
            variant: "unstyled",
            isSubtle: true,
            className: "inline-flex items-center gap-x-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image,
                    alt: "avatar",
                    priority: true,
                    unoptimized: true,
                    width: 32,
                    height: 32,
                    className: "rounded-full object-cover"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-sm",
                    children: "My Account"
                })
            ]
        })
    });
}
function LoginButton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/login",
        passHref: true,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
            variant: "unstyled",
            isSubtle: true,
            className: "mb-0.5",
            children: "Login"
        })
    });
}

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../packages/assets/icons/search.svg
var search_path;

function search_extends() { search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search_extends.apply(this, arguments); }



var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/react.createElement("svg", search_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), search_path || (search_path = /*#__PURE__*/react.createElement("path", {
    d: "m19.89 18.652-3.794-3.793a.37.37 0 0 0-.265-.11h-.413A6.499 6.499 0 0 0 10.5 4 6.5 6.5 0 0 0 4 10.5a6.499 6.499 0 0 0 10.75 4.92v.412c0 .1.04.193.109.265l3.793 3.794a.375.375 0 0 0 .532 0l.706-.706a.375.375 0 0 0 0-.532zM10.5 15.5c-2.763 0-5-2.237-5-5 0-2.762 2.237-5 5-5a5 5 0 0 1 5 5c0 2.763-2.238 5-5 5z",
    fill: "currentColor"
  })));
};

/* harmony default export */ var search = (SvgSearch);
;// CONCATENATED MODULE: ./src/components/layout/header/SiteWideSearch.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function SiteWideSearch() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-800",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex items-center justify-between gap-x-32 py-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    prefetch: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        "aria-label": "home",
                        className: "rounded-sm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary-green/25",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(releaseit_logo_green/* default */.Z, {
                            height: 36
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar, {})
            ]
        })
    });
}
function SearchBar() {
    var handleSubmit = // This submit handler is only run when not on "/search"
    function handleSubmit(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        var category = data.get("category");
        var query = data.get("query");
        router.push({
            pathname: "/search",
            query: _objectSpread({
                q: query
            }, category && {
                category: category
            })
        }, undefined, {
            shallow: true
        });
    };
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        onFocus: function() {
            return router.prefetch("/search");
        },
        className: " flex h-12 w-full max-w-3xl overflow-hidden rounded-md border border-black bg-white ring-primary-green/25 focus-within:ring-4 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                id: "category",
                name: "category",
                defaultValue: router.query.category,
                className: "border-none text-sm focus:ring-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "",
                        children: "All"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "baby-and-kids",
                        children: "Baby & Kids"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "fashion",
                        children: "Fashion"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "furniture",
                        children: "Furniture"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "garden-and-tools",
                        children: "Garden & Tools"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "home",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "office-and-storage",
                        children: "Office & Storage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "party-and-events",
                        children: "Party & Events"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "sports-and-recreation",
                        children: "Sports & Recreation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "technology",
                        children: "Technology"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "vehicles",
                        children: "Vehicles"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                orientation: "vertical",
                className: "mx-4 border-y-8 border-white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative grow",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-y-0 left-0 flex items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {
                            className: "h-6 w-6"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "query",
                        name: "query",
                        type: "search",
                        placeholder: "Search",
                        defaultValue: router.query.q,
                        required: true,
                        minLength: 2,
                        className: "h-full w-full border-none pl-10 text-sm focus:ring-0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                type: "submit",
                size: "sm",
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {
                    className: "h-6 w-6"
                }),
                className: "rounded-l-none border-l-black",
                children: "Search"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/layout/header/Header.tsx




function Header() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderPromoBar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                id: "header",
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteWideSearch, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar, {})
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../packages/assets/icons/compass.svg
var compass_path;

function compass_extends() { compass_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return compass_extends.apply(this, arguments); }



var SvgCompass = function SvgCompass(props) {
  return /*#__PURE__*/react.createElement("svg", compass_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), compass_path || (compass_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.616 12.616a.87.87 0 1 0-1.23-1.232.87.87 0 0 0 1.23 1.232zm3.138-5.37a.717.717 0 0 0-.244.042L9.89 9.315a.938.938 0 0 0-.573.573L7.289 15.51c-.205.569.375 1.244.958 1.244a.717.717 0 0 0 .243-.042l5.622-2.027a.938.938 0 0 0 .573-.574l2.027-5.621c.205-.569-.375-1.244-.958-1.244zm-2.129 6.38-5.084 1.832 1.833-5.084L15.46 8.54l-1.834 5.084zM12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9zm0 16.839c-4.322 0-7.839-3.517-7.839-7.839 0-4.322 3.517-7.839 7.839-7.839 4.322 0 7.839 3.517 7.839 7.839 0 4.322-3.517 7.839-7.839 7.839z",
    fill: "currentColor"
  })));
};

/* harmony default export */ var compass = (SvgCompass);
// EXTERNAL MODULE: ../../packages/assets/icons/ellipsis-h.svg
var ellipsis_h = __webpack_require__(77893);
;// CONCATENATED MODULE: ../../packages/assets/icons/plus-circle.svg
var plus_circle_path;

function plus_circle_extends() { plus_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_circle_extends.apply(this, arguments); }



var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/react.createElement("svg", plus_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), plus_circle_path || (plus_circle_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.645 11.782v.436c0 .24-.196.435-.435.435h-3.557v3.557c0 .24-.196.435-.435.435h-.436a.437.437 0 0 1-.435-.435v-3.557H7.79a.437.437 0 0 1-.435-.435v-.436c0-.24.196-.435.435-.435h3.557V7.79c0-.24.196-.435.435-.435h.436c.24 0 .435.196.435.435v3.557h3.557c.24 0 .435.196.435.435zM21 12c0 4.972-4.028 9-9 9s-9-4.028-9-9 4.028-9 9-9 9 4.028 9 9zm-1.161 0c0-4.351-3.531-7.839-7.839-7.839-4.351 0-7.839 3.531-7.839 7.839 0 4.351 3.531 7.839 7.839 7.839 4.351 0 7.839-3.531 7.839-7.839z",
    fill: "currentColor"
  })));
};

/* harmony default export */ var plus_circle = (SvgPlusCircle);
;// CONCATENATED MODULE: ./src/components/layout/MobileNavBar.tsx









function MobileNavBar() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "mobile-navbar",
        className: "mt-14 md:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
            className: "fixed inset-x-0 bottom-0 z-10 h-14 border-t bg-white",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                role: "navigation",
                className: "grid h-full grid-cols-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                        href: "/",
                        icon: compass,
                        children: "Explore"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                        href: "/category",
                        icon: menu,
                        children: "Categories"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                        href: "/search",
                        icon: search,
                        children: "Search"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                        href: "/create-listing",
                        icon: plus_circle,
                        children: "List Item"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                        href: "/my-account",
                        icon: ellipsis_h/* default */.Z,
                        children: "More"
                    })
                ]
            })
        })
    });
}
function NavItem(param) {
    var href = param.href, Icon = param.icon, children = param.children;
    var pathname = (0,next_router.useRouter)().pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: classnames_default()("inline-flex w-full flex-col items-center justify-center text-sm", pathname === href ? "text-mid-green" : "text-gray-800"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: children
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/layout/DefaultLayout.tsx





var NAVIGATION_QUERY = "\n  query NavigationQuery {\n    Navigation {\n      promoLinks {\n        title\n        href\n      }\n      categories {\n        __typename\n        title\n        href\n        featured {\n          title\n          href\n        }\n        popularBrands {\n          title\n          href\n        }\n        children {\n          ...NavigationCategoryRecursive\n          children {\n            ...NavigationCategoryRecursive\n            children {\n              ...NavigationCategoryRecursive\n            }\n          }\n        }\n      }\n    }\n  }\n\n  fragment NavigationCategoryRecursive on NavigationCategory {\n    title\n    href\n    featured {\n      title\n      href\n    }\n  }\n";
function DefaultLayout(param) {
    var children = param.children;
    useAuthRefresh();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex min-h-screen flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "grow",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavBar, {})
        ]
    });
}
/* harmony default export */ var layout_DefaultLayout = (DefaultLayout);


/***/ }),

/***/ 43231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _spinner_Spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66641);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78707);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var DEFAULT_ELEMENT = "button";
var variants = {
    "filled-primary": "\n    bg-primary-green\n    text-black\n    ring-primary-green/25\n  ",
    "filled-neutral": "\n    bg-gray-100 active:bg-gray-200\n    text-black\n    border-gray-600 disabled:border-gray-600\n    ring-black/25\n  ",
    "light-positive": "\n    bg-pastel-green\n    text-mid-green\n    ring-mid-green/25\n  ",
    "light-negative": "\n    bg-pastel-pink\n    text-error\n    ring-error/25\n  ",
    "light-neutral": "\n    bg-gray-600/10\n    text-gray-600\n    ring-gray-600/25\n  ",
    "text-neutral": "\n    bg-transparent active:bg-gray-600/5\n    text-gray-600\n    ring-gray-600/25\n  ",
    "text-positive": "\n    bg-transparent active:bg-mid-green/5\n    text-mid-green\n    ring-mid-green/25\n  ",
    "text-negative": "\n    bg-transparent active:bg-error/5\n    text-error\n    ring-error/25\n  ",
    "text-dark": "\n    bg-transparent active:bg-gray-400/5\n    text-black\n    ring-black/25\n  ",
    "text-light": "\n    bg-transparent active:bg-gray-200/5\n    text-white\n    ring-white/25\n  "
};
var sizes = {
    xs: "gap-x-2 text-sm",
    sm: "min-h-[2rem] px-4 text-sm",
    md: "min-h-[3rem] px-8 text-base"
};
var Button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var as = _param.as, children = _param.children, _type = _param.type, type = _type === void 0 ? "button" : _type, _variant = _param.variant, variant = _variant === void 0 ? "filled-primary" : _variant, _size = _param.size, size = _size === void 0 ? "md" : _size, startIcon = _param.startIcon, endIcon = _param.endIcon, isDisabled = _param.isDisabled, isLoading = _param.isLoading, className = _param.className, props = _objectWithoutProperties(_param, [
        "as",
        "children",
        "type",
        "variant",
        "size",
        "startIcon",
        "endIcon",
        "isDisabled",
        "isLoading",
        "className"
    ]);
    var Component = as || DEFAULT_ELEMENT;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Component, _objectSpread({}, props, {
        ref: ref,
        type: type,
        disabled: isDisabled || isLoading,
        className: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .cnm */ .w)("\n            inline-flex\n            select-none appearance-none\n            items-center justify-center gap-x-2\n            rounded-md border border-transparent font-medium\n            transition\n            focus:ring-4 focus-visible:outline-none\n\n            disabled:pointer-events-none\n            disabled:border-transparent\n            disabled:opacity-50\n          ", variants[variant], sizes[size], className),
        children: [
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_spinner_Spinner__WEBPACK_IMPORTED_MODULE_3__/* .Spinner */ .$, {
                size: "sm",
                className: "text-current"
            }),
            !isLoading && startIcon,
            children,
            !isLoading && endIcon
        ]
    }));
});



/***/ }),

/***/ 46348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zF": function() { return /* binding */ Collapsible; }
/* harmony export */ });
/* unused harmony exports CollapsibleTrigger, CollapsibleContent */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71206);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function Collapsible(_param) {
    var props = _extends({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_1__/* .Root */ .fC, _objectSpread({}, props));
}
var CollapsibleTrigger = _radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_1__/* .Trigger */ .xz;
var CollapsibleContent = _radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_1__/* .Content */ .VY;
Collapsible.Trigger = CollapsibleTrigger;
Collapsible.Content = CollapsibleContent;


/***/ }),

/***/ 82002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78707);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Divider(_param) {
    var _orientation = _param.orientation, orientation = _orientation === void 0 ? "horizontal" : _orientation, isDecorative = _param.isDecorative, className = _param.className, props = _objectWithoutProperties(_param, [
        "orientation",
        "isDecorative",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({}, props, {
        role: isDecorative ? "none" : "separator",
        className: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .cnm */ .w)("bg-gray-300", orientation === "horizontal" ? "h-px" : "w-px", className)
    }));
}


/***/ }),

/***/ 48994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78707);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var DEFAULT_ELEMENT = "a";
var variants = {
    primary: "text-mid-green ring-mid-green/25",
    neutral: "text-gray-500 ring-gray-500/25",
    unstyled: null
};
var Link = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var as = _param.as, children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _isSubtle = _param.isSubtle, isSubtle = _isSubtle === void 0 ? false : _isSubtle, _isStrong = _param.isStrong, isStrong = _isStrong === void 0 ? false : _isStrong, className = _param.className, props = _objectWithoutProperties(_param, [
        "as",
        "children",
        "variant",
        "isSubtle",
        "isStrong",
        "className"
    ]);
    var Component = as || DEFAULT_ELEMENT;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _objectSpread({}, props, {
        ref: ref,
        className: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .cnm */ .w)("\n            rounded-sm ring-mid-green/25 transition hover:underline focus:underline\n            focus-visible:outline-none focus-visible:ring-4\n          ", variant && variants[variant], !isSubtle && "underline", isStrong && "font-medium", className),
        children: children
    }));
});



/***/ }),

/***/ 66641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var sizes = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-12 w-12",
    xl: "h-24 w-24"
};
var variants = {
    light: "text-white",
    primary: "text-blue-600"
};
function Spinner(param) {
    var _size = param.size, size = _size === void 0 ? "md" : _size, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("animate-spin", sizes[size], variants[variant], className),
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "data-testid": "loading",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        className: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "sr-only",
                children: "Loading"
            })
        ]
    });
}


/***/ }),

/***/ 78707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ cnm; }
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67579);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function cnm() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_1__/* .twMerge */ .m)(classnames__WEBPACK_IMPORTED_MODULE_0___default().apply(void 0, _toConsumableArray(classes)));
}


/***/ })

}]);